import type { localeType, localeTextsType } from '../type'
import enUS from './en-US'
import zhCN from './zh-CN'

const localeMap: localeTextsType = {
  'en-US': enUS,
  'zh-CN': zhCN
}

let locale: localeType = 'en-US'

export const getLocaleText = (key: string) => {
  const map: { [key: string]: string } | undefined = localeMap[locale]
  return map?.[key] || key
}

export const setLocale = (newLocale: localeType) => {
  locale = newLocale
}
/**
 * 更新特定语言 locale 词条
 * @param localeTexts 
 */

export const setLocalTexts = (localeTexts: localeTextsType) => {
  const keys = Object.keys(localeMap) as localeType[]

  for (let index = 0; index < keys.length; index += 1) {
    const key = keys[index]
    if (typeof localeTexts[key] !== 'undefined') {
      localeMap[key] = {
        ...localeMap[key],
        ...localeTexts[key]
      }
    }
  }
}